import { render, staticRenderFns } from "./CommissionContent.vue?vue&type=template&id=d4fccb68"
import script from "./CommissionContent.vue?vue&type=script&lang=js"
export * from "./CommissionContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports